/* WeldRda — nouveau design. Product page logic, gallery, sticky bar, delivery dates, sort,
   collection filters (live count, price slider), "Complétez le look" quick-add panels. */
(function () {
'use strict';
/* Theme cart events (@shopify/events) are ES modules. Load them through a small module script:
   a literal import() in this file is rewritten by Shopify's minifier and breaks. */
var wrCartEvPromise = null;
function wrCartEvents() {
if (wrCartEvPromise) return wrCartEvPromise;
wrCartEvPromise = new Promise(function (resolve) {
if (window.__wrCartLinesEv) { resolve(window.__wrCartLinesEv); return; }
var done = false;
function finish() { if (done) return; done = true; resolve(window.__wrCartLinesEv || null); }
window.addEventListener('wr:cart-events', finish, { once: true });
var s = document.createElement('script');
s.type = 'module';
s.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__wrCartLinesEv = CartLinesUpdateEvent; window.dispatchEvent(new Event('wr:cart-events'));";
document.head.appendChild(s);
setTimeout(finish, 4000);
});
return wrCartEvPromise;
}
function formatDH(cents) {
var n = cents / 100;
var s = (Math.round(n) === n) ? String(n) : n.toFixed(2).replace('.', ',');
return s + ' DH';
}
function frDate(d) {
try {
return new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Africa/Casablanca' }).format(d);
} catch (e) {
return d.toLocaleDateString('fr-FR');
}
}
function frShort(d) {
try {
return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short', timeZone: 'Africa/Casablanca' }).format(d);
} catch (e) {
return d.toLocaleDateString('fr-FR');
}
}
function initGallery(root) {
var track = root.querySelector('[data-track]');
if (!track) return;
var dotsWrap = root.querySelector('[data-dots]');
var thumbsWrap = root.parentElement ? root.parentElement.querySelector('[data-thumbs]') : null;
var slides = Array.prototype.slice.call(track.children);
var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('.wr-thumb')) : [];
function shown(list) { return list.filter(function (el) { return !el.hidden; }); }
function setActive(i) {
if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('is-active', k === i); });
shown(thumbs).forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
}
function go(i, smooth) {
track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
setActive(i);
}
var raf;
track.addEventListener('scroll', function () {
cancelAnimationFrame(raf);
raf = requestAnimationFrame(function () {
var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
setActive(i);
});
}, { passive: true });
thumbs.forEach(function (t) {
t.addEventListener('click', function () {
var i = shown(thumbs).indexOf(t);
if (i >= 0) go(i, true);
});
});
root.goToMedia = function (mediaId) {
var list = shown(slides);
for (var i = 0; i < list.length; i++) {
if (String(list[i].getAttribute('data-media-id')) === String(mediaId)) { go(i, true); return; }
}
};
/* Show only the photos of one colour (plus shared photos). If the colour has no photo, show everything. */
root.filterColor = function (color) {
var has = slides.some(function (s) { return s.getAttribute('data-color') === color; });
slides.forEach(function (s, k) {
var c = s.getAttribute('data-color');
var show = !has || c === null || c === '*' || c === color;
s.hidden = !show;
if (thumbs[k]) thumbs[k].hidden = !show;
});
var n = shown(slides).length;
if (dotsWrap) {
dotsWrap.innerHTML = '';
for (var i = 0; i < n; i++) dotsWrap.appendChild(document.createElement('span'));
dotsWrap.hidden = n < 2;
}
if (thumbsWrap) thumbsWrap.hidden = n < 2;
go(0, false);
};
}
function initProduct(root) {
var dataEl = root.querySelector('[data-wr-variants]');
var variants = [];
try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
var form = root.querySelector('form.wr-form');
var input = root.querySelector('[data-variant-input]');
var fieldsets = root.querySelectorAll('.wr-opt');
var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 3;
var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
if (isNaN(colorIndex)) colorIndex = -1;
var lastColor = null;
var gallery = root.querySelector('[data-wr-gallery]');
var atc = root.querySelector('[data-atc]');
var atcText = root.querySelector('[data-atc-text]');
var atcLabel = (atc && atc.getAttribute('data-label')) || (atcText ? atcText.textContent : 'Ajouter au panier');
var requireSize = root.hasAttribute('data-require-size');
var noUrl = root.hasAttribute('data-wr-nourl');
var stickyAtc = root.querySelector('[data-sticky-atc]');
var stickyPrice = root.querySelector('[data-sticky-price]');
var stickyVariant = root.querySelector('[data-sticky-variant]');
if (gallery) initGallery(gallery);
if (form && document.getElementById('cart-drawer')) wrCartEvents();
function selected() {
var out = [];
Array.prototype.forEach.call(fieldsets, function (fs) {
var c = fs.querySelector('input[type=radio]:checked');
out[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
});
return out;
}
function findVariant(opts) {
for (var i = 0; i < variants.length; i++) {
var v = variants[i], ok = true;
for (var k = 0; k < opts.length; k++) { if (opts[k] != null && v.options[k] !== opts[k]) { ok = false; break; } }
if (ok) return v;
}
return null;
}
function markAvailability(opts) {
Array.prototype.forEach.call(fieldsets, function (fs) {
var idx = parseInt(fs.getAttribute('data-option-index'), 10);
fs.querySelectorAll('input[type=radio]').forEach(function (r) {
var test = opts.slice(); test[idx] = r.value;
var any = variants.some(function (v) {
for (var k = 0; k < test.length; k++) { if (test[k] != null && v.options[k] !== test[k]) return false; }
return v.available;
});
var label = fs.querySelector('label[for="' + r.id + '"]');
if (label && label.classList.contains('wr-size')) label.classList.toggle('is-unavailable', !any);
});
});
}
function updateStock(v) {
var box = root.querySelector('[data-stock]');
if (!box) return;
if (v && v.tracked && v.policy === 'deny' && v.qty > 0 && v.qty <= threshold) {
var sizeTxt = (sizeIndex >= 0 && v.options[sizeIndex]) ? ' en taille ' + v.options[sizeIndex] : '';
box.querySelector('[data-stock-text]').textContent = ' — plus que ' + v.qty + (v.qty > 1 ? ' pièces' : ' pièce') + sizeTxt;
box.querySelector('[data-stock-bar]').style.width = Math.max(10, Math.round(v.qty / threshold * 100 * 0.6)) + '%';
box.hidden = false;
} else {
box.hidden = true;
}
}
function update() {
var opts = selected();
var v = findVariant(opts);
var colorChanged = false;
if (colorIndex >= 0 && opts[colorIndex] != null && opts[colorIndex] !== lastColor) {
lastColor = opts[colorIndex];
colorChanged = true;
if (gallery && gallery.filterColor) gallery.filterColor(lastColor);
}
Array.prototype.forEach.call(fieldsets, function (fs) {
var c = fs.querySelector('input[type=radio]:checked');
var lab = fs.querySelector('[data-option-label]');
if (lab && c) lab.textContent = c.value;
});
markAvailability(opts);
/* Quick-add panel: no size chosen yet → keep the button off and say what to do. */
if (requireSize && sizeIndex >= 0 && opts[sizeIndex] == null) {
if (atc) atc.disabled = true;
if (atcText) atcText.textContent = 'Choisissez votre taille';
if (v) {
var p0 = root.querySelector('[data-price]');
if (p0) p0.textContent = formatDH(v.price);
}
return;
}
if (!v) {
if (atc) atc.disabled = true;
if (atcText) atcText.textContent = 'Indisponible';
if (stickyAtc) stickyAtc.disabled = true;
updateStock(null);
return;
}
if (input) input.value = v.id;
var price = root.querySelector('[data-price]');
if (price) price.textContent = formatDH(v.price);
var cmp = root.querySelector('[data-compare]');
if (cmp) {
if (v.compare && v.compare > v.price) { cmp.textContent = formatDH(v.compare); cmp.hidden = false; }
else { cmp.hidden = true; }
}
if (stickyPrice) stickyPrice.textContent = formatDH(v.price);
if (stickyVariant) stickyVariant.textContent = (sizeIndex >= 0 && v.options[sizeIndex]) ? ' · ' + v.options[sizeIndex] : '';
if (atc) atc.disabled = !v.available;
if (atcText) atcText.textContent = v.available ? atcLabel : 'Épuisé';
if (stickyAtc) { stickyAtc.disabled = !v.available; stickyAtc.textContent = v.available ? atcLabel : 'Épuisé'; }
updateStock(v);
if (v.media && gallery && gallery.goToMedia && (colorChanged || colorIndex < 0)) gallery.goToMedia(v.media);
if (!noUrl) {
try {
var url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
} catch (e) {}
}
}
Array.prototype.forEach.call(fieldsets, function (fs) {
fs.addEventListener('change', update);
});
if (fieldsets.length) {
if (colorIndex >= 0) {
lastColor = selected()[colorIndex];
if (lastColor != null && gallery && gallery.filterColor) gallery.filterColor(lastColor);
}
var initial = findVariant(selected());
updateStock(initial);
markAvailability(selected());
if (stickyVariant && initial && sizeIndex >= 0) stickyVariant.textContent = ' · ' + initial.options[sizeIndex];
} else if (variants.length) {
updateStock(variants[0]);
}
/* Add to cart without leaving the page, then open the cart drawer (theme events keep the drawer in sync).
   Falls back to the normal form submit (cart page) if the drawer is missing or something fails. */
function atcMessage(text) {
var msg = root.querySelector('[data-atc-msg]');
if (!msg && atc && atc.parentNode) {
msg = document.createElement('p');
msg.setAttribute('data-atc-msg', '');
msg.setAttribute('role', 'alert');
msg.style.cssText = 'margin:10px 0 0;font-size:13px;color:#A3292A;';
atc.parentNode.appendChild(msg);
}
if (!msg) return;
msg.textContent = text || '';
msg.hidden = !text;
}
function openDrawer(drawer) {
try {
if (typeof drawer.open === 'function') { drawer.open(); return; }
if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; }
var trigger = document.querySelector('[aria-controls="cart-drawer"]');
if (trigger) { trigger.click(); return; }
} catch (e) {}
window.location.href = cartUrl();
}
function cartUrl() {
var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
return r + 'cart';
}
/* Quick-add panel ("Complétez le look"): close it and show "Ajouté" on the button that opened it. */
function markAdded() {
var dlg = root.closest ? root.closest('dialog') : null;
if (!dlg || !dlg.id) return;
if (dlg.open) dlg.close();
document.querySelectorAll('[data-open-dialog="' + dlg.id + '"]').forEach(function (b) {
b.classList.add('is-added');
var l = b.querySelector('[data-look-label]');
if (l) l.textContent = 'Ajouté';
});
}
function ajaxAdd(drawer) {
var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var fd = new FormData(form);
var qty = parseInt(fd.get('quantity'), 10) || 1;
var ids = [];
document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
if (ids.length) fd.append('sections', ids.join(','));
var pid = root.getAttribute('data-product-id') || '';
if (!pid) { try { pid = String(window.ShopifyAnalytics.meta.product.id); } catch (e) {} }
var Ev = null, deferred = null, added = false;
form.setAttribute('data-wr-busy', '1');
if (atc) atc.disabled = true;
if (stickyAtc) stickyAtc.disabled = true;
if (atcText) atcText.textContent = 'Ajout…';
atcMessage('');
wrCartEvents().then(function (C) { Ev = C || null; })
.then(function () {
if (Ev) {
deferred = Ev.createPromise();
form.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: fd.get('id'), quantity: qty }], promise: deferred.promise }));
}
return fetch(r + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd });
})
.then(function (res) { return res.json(); })
.then(function (res) {
var failed = !!(res && res.status);
if (!failed) added = true;
return fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).then(function (cart) {
if (deferred) {
deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'wr-product', itemCount: qty, productId: pid, sections: failed ? undefined : res.sections, didError: failed } });
}
if (failed) { atcMessage(res.description || res.message || 'Impossible d’ajouter cet article.'); return; }
markAdded();
if (!deferred) { window.location.href = cartUrl(); return; }
openDrawer(drawer);
});
})
.catch(function (err) {
if (deferred) { try { deferred.reject(err); } catch (e) {} }
if (added) { window.location.href = cartUrl(); }
else { form.submit(); }
})
.then(function () {
form.setAttribute('data-wr-busy', '0');
update();
});
}
if (form) {
form.addEventListener('submit', function (e) {
if (form.getAttribute('data-wr-busy') === '1') { e.preventDefault(); return; }
var drawer = document.getElementById('cart-drawer');
if (!drawer || !window.fetch || !window.FormData) {
if (atc) { setTimeout(function () { atc.disabled = true; }, 0); }
return;
}
e.preventDefault();
ajaxAdd(drawer);
});
}
var now = new Date();
var dMin = parseInt(root.getAttribute('data-days-min'), 10) || 1;
var dMax = parseInt(root.getAttribute('data-days-max'), 10) || 3;
var t = root.querySelector('[data-date-today]');
var c = root.querySelector('[data-date-confirm]');
var dl = root.querySelector('[data-date-delivery]');
if (t) t.textContent = frDate(now);
if (c) c.textContent = frDate(now);
if (dl) {
var a = new Date(now.getTime() + dMin * 86400000);
var b = new Date(now.getTime() + dMax * 86400000);
dl.textContent = frShort(a) + ' – ' + frShort(b);
}
root.querySelectorAll('[data-open-dialog]').forEach(function (btn) {
btn.addEventListener('click', function () {
var d = document.getElementById(btn.getAttribute('data-open-dialog'));
if (d && d.showModal) d.showModal();
});
});
root.querySelectorAll('dialog').forEach(function (d) {
d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
d.querySelectorAll('[data-close-dialog]').forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
});
var sticky = root.querySelector('[data-sticky]');
if (sticky && atc && 'IntersectionObserver' in window) {
var io = new IntersectionObserver(function (entries) {
var e = entries[0];
var show = !e.isIntersecting && e.boundingClientRect.top < 0;
sticky.classList.toggle('is-visible', show);
sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
if (stickyAtc) stickyAtc.tabIndex = show ? 0 : -1;
document.body.classList.toggle('wr-sticky-on', show && window.innerWidth < 990);
});
io.observe(atc);
}
}
function initSort() {
document.querySelectorAll('[data-wr-sort]').forEach(function (sel) {
sel.addEventListener('change', function () {
var url = new URL(window.location.href);
url.searchParams.set('sort_by', sel.value);
url.searchParams.delete('page');
window.location.href = url.toString();
});
});
document.querySelectorAll('.wr-filter').forEach(function (d) {
document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
});
}
/* Cart page: the header bag icon only reloaded the same page. Scroll to the COD order button and make it pulse. */
function initCartIcon() {
if (!/\/cart\/?$/.test(window.location.pathname)) return;
if (!document.getElementById('wr-pulse-style')) {
var st = document.createElement('style');
st.id = 'wr-pulse-style';
st.textContent = '@keyframes wrPulse{0%{box-shadow:0 0 0 0 rgba(21,21,21,.45)}100%{box-shadow:0 0 0 14px rgba(21,21,21,0)}}.wr-pulse{animation:wrPulse .9s ease-out 2}';
document.head.appendChild(st);
}
document.querySelectorAll('.header-actions a[href$="/cart"], a.action__cart').forEach(function (a) {
if (a.getAttribute('data-wr-cart-icon') === '1') return;
a.setAttribute('data-wr-cart-icon', '1');
a.addEventListener('click', function (e) {
e.preventDefault();
var btn = document.querySelector('#es-popup-button, .es-popup-button, .cart__checkout-button');
if (!btn) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
btn.classList.remove('wr-pulse');
void btn.offsetWidth;
btn.classList.add('wr-pulse');
});
});
}
/* Quick-add panels live outside the product element: close on the × button and on a tap outside. */
function initQuickDialogs() {
document.querySelectorAll('dialog[data-wr-qa]').forEach(function (d) {
if (d.getAttribute('data-wr-bound') === '1') return;
d.setAttribute('data-wr-bound', '1');
d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
d.querySelectorAll('[data-close-dialog]').forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
});
}
/* Collection filters: panel, price slider, live "Voir les N articles", clean URLs. */
function initFilters(plp) {
var btn = plp.querySelector('[data-wr-fd-open]');
var dlg = btn ? document.getElementById(btn.getAttribute('data-wr-fd-open')) : null;
if (!dlg || dlg.getAttribute('data-wr-bound') === '1') return;
dlg.setAttribute('data-wr-bound', '1');
var form = dlg.querySelector('[data-wr-filter-form]');
var submit = dlg.querySelector('[data-wr-fd-submit]');
var label = dlg.querySelector('[data-wr-fd-label]');
var reset = dlg.querySelector('[data-wr-fd-reset]');
var sid = plp.getAttribute('data-section-id');
var action = form.getAttribute('action');
var range = dlg.querySelector('[data-wr-range]');
var rMin, rMax, nMin, nMax, fill, lMin, lMax, max = 0;
function lock(on) { document.documentElement.classList.toggle('wr-lock', on); }
btn.addEventListener('click', function () {
if (typeof dlg.showModal === 'function') { dlg.showModal(); lock(true); }
});
dlg.addEventListener('close', function () { lock(false); });
dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
dlg.querySelectorAll('[data-wr-fd-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
function setLabel(n) {
if (!label) return;
if (n === 0) { label.textContent = 'Aucun article'; submit.disabled = true; return; }
submit.disabled = false;
label.textContent = n === 1 ? 'Voir l’article' : 'Voir les ' + n + ' articles';
}
if (range) {
max = parseInt(range.getAttribute('data-max'), 10) || 0;
rMin = range.querySelector('[data-range-min]');
rMax = range.querySelector('[data-range-max]');
nMin = range.querySelector('[data-num-min]');
nMax = range.querySelector('[data-num-max]');
fill = range.querySelector('[data-range-fill]');
lMin = range.querySelector('[data-range-label-min]');
lMax = range.querySelector('[data-range-label-max]');
}
function paint() {
if (!range || !max) return;
var a = parseInt(rMin.value, 10) || 0, b = parseInt(rMax.value, 10) || 0;
fill.style.left = (a / max * 100) + '%';
fill.style.right = (100 - b / max * 100) + '%';
lMin.textContent = a + ' DH';
lMax.textContent = b + ' DH';
}
if (range) {
rMin.addEventListener('input', function () {
var a = parseInt(rMin.value, 10), b = parseInt(rMax.value, 10);
if (a > b - 10) { a = Math.max(0, b - 10); rMin.value = a; }
nMin.value = a > 0 ? a : '';
paint();
});
rMax.addEventListener('input', function () {
var a = parseInt(rMin.value, 10), b = parseInt(rMax.value, 10);
if (b < a + 10) { b = Math.min(max, a + 10); rMax.value = b; }
nMax.value = b < max ? b : '';
paint();
});
nMin.addEventListener('change', function () {
var a = Math.max(0, Math.min(max, parseInt(nMin.value, 10) || 0));
nMin.value = a > 0 ? a : '';
rMin.value = a;
if (parseInt(rMax.value, 10) < a) { rMax.value = a; nMax.value = a < max ? a : ''; }
paint();
});
nMax.addEventListener('change', function () {
var v = parseInt(nMax.value, 10);
var b = isNaN(v) ? max : Math.max(0, Math.min(max, v));
nMax.value = b < max ? b : '';
rMax.value = b;
if (parseInt(rMin.value, 10) > b) { rMin.value = b; nMin.value = b > 0 ? b : ''; }
paint();
});
paint();
}
/* Only send what is set: no empty price, no price equal to the whole range. */
function params() {
var out = new URLSearchParams();
var fd = new FormData(form);
fd.forEach(function (val, key) {
val = String(val).trim();
if (val === '') return;
if (range && nMin && key === nMin.name && (parseInt(val, 10) || 0) <= 0) return;
if (range && nMax && key === nMax.name && (parseInt(val, 10) || 0) >= max) return;
out.append(key, val);
});
return out;
}
var timer = null, seq = 0;
function refresh() {
clearTimeout(timer);
timer = setTimeout(function () {
var p = params();
p.set('section_id', sid);
var mine = ++seq;
submit.classList.add('is-loading');
fetch(action + '?' + p.toString(), { headers: { 'Accept': 'text/html' } })
.then(function (r) { return r.text(); })
.then(function (html) {
if (mine !== seq) return;
var m = html.match(/data-wr-count="(\d+)"/);
if (m) setLabel(parseInt(m[1], 10));
})
.catch(function () {})
.then(function () { if (mine === seq) submit.classList.remove('is-loading'); });
}, 250);
}
form.addEventListener('change', refresh);
form.addEventListener('submit', function (e) {
e.preventDefault();
var q = params().toString();
window.location.href = action + (q ? '?' + q : '');
});
if (reset) {
reset.addEventListener('click', function () {
form.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.checked = false; });
if (range) { rMin.value = 0; rMax.value = max; nMin.value = ''; nMax.value = ''; paint(); }
refresh();
});
}
}
function init() {
document.querySelectorAll('[data-wr-product]').forEach(initProduct);
initQuickDialogs();
document.querySelectorAll('[data-wr-plp]').forEach(initFilters);
initSort();
initCartIcon();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
document.addEventListener('shopify:section:load', init);
})();
